import {post} from '../utils/ajaxHelper';

/**
 * Handles POST to server for applink submission
 *
 * @param {*} travelerAppBrand
 */
function postApplink(travelerAppBrand) {
    const url = '/pdp/api/link';
    const applinkRequest = {
        mobileLink: {
            key: 'traveler_home',
            site: travelerAppBrand
        },
        tracking: {
            campaign: 'inquiry_success',
            channel: 'inquiry',
            feature: 'app_store_button'
        }
    };
    const headers = {
        'content-type': 'application/json'
    };

    return post(url, applinkRequest, headers, true);
}

export default postApplink;
export {postApplink};
